import React, { useEffect, useRef, useState } from "react";
import MenuItemLayout from "./menuItemLayout/MenuItemLayout";
import banner from "../../assets/images/intern_banner.png";
import heroMobile from "../../assets/images/intern-mob.png";
import { Col, Row } from "antd";
import ReportsCard from "../../biblio/Cards/ReportsCard";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import {
  toGetAnnualReports,
  toGetFeedback,
  toGetFinancialStatements,
  toGetGoalsPrograms,
  toGetOperationalPlans,
  toGetPerformanceReports,
  toGetQualityDevelopment,
  toGetRegualationsSystems,
  toGetOfficials,
  toGetAssociationData,
} from "../../apis/actions/reports.actions";
import Loader from "../../biblio/Loader/Loader";
import PaginationComponent from "../../biblio/Pagination/PaginationComponent";
import { scroll } from "../../components/utils/utils";

interface ReportsPageProps {
  type: string;
}

const ReportsPage = ({ type }: ReportsPageProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { reports, color, loading } = useSelector(
    (state: RootState) => state.reports
  );

  const currentRef = useRef<HTMLDivElement>(null);

  const [state, setState] = useState({ title: "", subTitle: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  useEffect(() => {
    switch (type) {
      case "annual_reports":
        dispatch(toGetAnnualReports());
        setState({ title: "من نحن", subTitle: "التقارير السنوية" });
        break;
      case "quality_development":
        dispatch(toGetQualityDevelopment());
        setState({ title: "من نحن", subTitle: "التطوير و الجودة" });
        break;
      case "performance_reports":
        dispatch(toGetPerformanceReports());
        setState({ title: "من نحن", subTitle: "تقارير و مؤشرات الأداء" });
        break;
      case "regulations":
        dispatch(toGetRegualationsSystems());
        setState({
          title: "الحوكمة",
          subTitle: "اللوائح و الأنظمة",
        });
        break;
      case "operational_plans":
        dispatch(toGetOperationalPlans());
        setState({
          title: "الحوكمة",
          subTitle: "الخطط التشغيلية",
        });
        break;
      case "financial_statement":
        dispatch(toGetFinancialStatements());
        setState({
          title: "الحوكمة",
          subTitle: "القوائم المالية",
        });
        break;
      case "goals_programs":
        dispatch(toGetGoalsPrograms());
        setState({
          title: "الحوكمة",
          subTitle: " أهداف و برامج الجمعية",
        });
        break;
      case "feedback":
        dispatch(toGetFeedback());
        setState({
          title: "الحوكمة",
          subTitle: "التغذية الراجعة",
        });
        break;
      case "officials":
        dispatch(toGetOfficials());
        setState({
          title: "الحوكمة",
          subTitle: "بيانات القائمين على الجمعية",
        });
        break;
      case "AssociationData":
        dispatch(toGetAssociationData());
        setState({
          title: "الحوكمة",
          subTitle: "بيانات الجمعية",
        });
        break;
      default:
        break;
    }
  }, [dispatch, type]);

  // Sorting the data by sequence
  const sortedData = reports
    .map((report: any) => report)
    .sort((a: any, b: any) => a.sequence - b.sequence);

  // Pagination logic
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedReports = sortedData.slice(startIndex, endIndex);

  if (loading) return <Loader />;

  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title={state.title}
      subTitle={state.subTitle}
      urlImage={banner}
      className="takaful--our-story"
    >
      <Row
        dir="rtl"
        gutter={[16, 16]}
        className="takaful--reports-container"
        ref={currentRef}
        style={{ margin: "1rem" }}
      >
        {paginatedReports &&
          paginatedReports.map((item: any, index: number) => (
            <>
              <Col key={index} xxl={8} xl={8} lg={8} md={12} sm={24} xs={24}>
                <ReportsCard
                  type={"reports"}
                  item={item}
                  index={startIndex + index}
                  color={color}
                  key={index}
                />
              </Col>
            </>
          ))}
      </Row>

      <div className="takaful--pagination-container">
        {reports && reports.length > itemsPerPage && (
          <PaginationComponent
            active={currentPage}
            total={reports.length}
            itemPerPage={itemsPerPage}
            scroll={() => scroll(currentRef)}
            setActive={(nb) => updateActive(nb)}
          />
        )}
      </div>
    </MenuItemLayout>
  );
};

export default ReportsPage;
